import { FormattedMessage } from 'components/shared/Intl';
import type { IntlKey } from 'locales';
import type { UnderlyingCodeType } from 'models/underlying/base';
import { FC, ReactNode, useContext } from 'react';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { WorkspaceAnalyticCategoryContext } from 'shared/middlewares/analytics/loggerContext';
import { capitalizeFirstletter } from 'utils/string';

import { HeaderCell } from '../../HeaderCell';

export interface HeaderProps {
  children?: ReactNode;
  switchCurrentCodeType?: () => void;
  type?: UnderlyingCodeType;
}

function getHeaderTranslationKey(type: UnderlyingCodeType): IntlKey {
  switch (type) {
    case 'Bloomberg':
      return 'quote.underlyingsGrid.header.Bloomberg';
    case 'BloombergComposite':
      return 'quote.underlyingsGrid.header.BloombergComposite';
    case 'CurveName':
      return 'quote.underlyingsGrid.header.CurveName';
    case 'Eliot':
      return 'quote.underlyingsGrid.header.Eliot';
    case 'PrimaryRootName':
      return 'quote.underlyingsGrid.header.PrimaryRootName';
    case 'Ric':
      return 'quote.underlyingsGrid.header.Ric';
    case 'Reuters':
      return 'quote.underlyingsGrid.header.Reuters';
    case 'Isin':
      return 'quote.underlyingsGrid.header.Isin';
    case 'Galaxy':
      return 'quote.underlyingsGrid.header.Galaxy';
    case 'Unknown':
      return 'quote.underlyingsGrid.header.Unknown';
    case 'Name':
      return 'quote.underlyingsGrid.header.Name';
    default:
      return `quote.underlyingsGrid.header.${type}` as any;
  }
}
export const Header: FC<HeaderProps> = ({ type, switchCurrentCodeType, children }) => {
  const logAnalyticsCategory = useContext(WorkspaceAnalyticCategoryContext);
  return (
    <HeaderCell>
      <div className="align-items-center d-flex flex-nowrap justify-content-between">
        {type && <FormattedMessage id={getHeaderTranslationKey(type)} defaultMessage={capitalizeFirstletter(type)} />}
        {switchCurrentCodeType && (
          <button
            className="btn btn-icon btn-link text-end"
            onClick={() => {
              logAnalytics.trackEvent(logAnalyticsCategory, 'Switch underlyings');
              switchCurrentCodeType();
            }}
            type="button"
          >
            <i className="icon icon-md">swap_horiz</i>
          </button>
        )}
        {children}
      </div>
    </HeaderCell>
  );
};
